// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-i_hi","catalogByServiceItem__title":"c-i_hj"};